import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NewsService } from '../services/news/news.service';
import { SharedService } from '../services/Shared/Shared.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NewscommentService } from '../services/newscomment/newscomment.service';
import { environment } from '../../environments/environment';
import { SpeechSynthesisUtteranceFactoryService, SpeechSynthesisService, } from '@kamiazya/ngx-speech-synthesis';
import { ActivatedRoute } from '@angular/router';
import { RepositoryService } from '../services/repository/repository.service';

@Component({
  selector: 'app-sharednews',
  templateUrl: './sharednews.component.html',
  styleUrls: ['./sharednews.component.css'],
  providers: [
    SpeechSynthesisUtteranceFactoryService,
  ],
})
export class SharednewsComponent implements OnInit {

  public newsId;
  public CompetitorResult;
  public IndustryResult;
  public NewsImageResult;
  public AttachmentResult: any = [];
  public EmailBody = '';
  public ShareEmailId;
  public NewsData: any = [];
  public NewsReadContent: any = [];
  public WebsiteLink = environment.ImagePath;
  public articleType;
  public RepoResult;
  public RepoData:any = [];

  selectedItemsCategorization = [];
  selectedItemsProducts = [];
  selectedItemsIndication = [];


  public NewsResult;
  public newsmodel = {
    ID: null,
    Title: null,
    ShortDescription: null,
    LongDescription: null,
    Categorization: [null],
    Products: [null],
    Source: null,
    SourceLink: null,
    Indications: [null],
    CompanyId: null,
    CreatedBy: null,//this.sharedService.getUserDetail('Userid'),
    ModifiedBy: null
  }

  constructor(
    private newsService: NewsService, 
    private sharedService: SharedService, 
    private renderer: Renderer2,
    private newscommentService: NewscommentService,
    public speechFactory: SpeechSynthesisUtteranceFactoryService,
    public speechService: SpeechSynthesisService,
    private route: ActivatedRoute,
    private repoService: RepositoryService,
  ) { 

    this.route.queryParams.subscribe(params => {
        this.newsId = params['share'];
        this.articleType = params['article'];
    });
  }

  ngOnInit(): void {
    console.log(this.newsId);
    console.log(this.articleType);
    //this.newsId = '5f7b0f503fde767430cd0147';
    if(this.articleType == 'news'){
      this.newsService.GetSharedNewsDetailsById(this.newsId).subscribe(result => {
        if (result) {
          console.log(result)

          this.NewsResult = result;
          if (this.NewsResult[0].NewsImage != undefined && this.NewsResult[0].NewsImage.ImageFile != null) {
            this.NewsImageResult = this.NewsResult[0].NewsImage;
          }
          if (this.NewsResult[0].Attachments != undefined && this.NewsResult[0].Attachments.length > 0) {
            this.AttachmentResult = this.NewsResult[0].Attachments;
          }
          var companyid = this.NewsResult[0].CompanyId;
          if (this.NewsResult[0].CompanyId != null) {
            companyid = this.NewsResult[0].CompanyId._id;
          }
          var CategorizationArray = this.NewsResult[0].Categorization;
          this.selectedItemsCategorization=[];
          for (var i = 0; i < CategorizationArray.length; i++) {
            this.selectedItemsCategorization.push(
              {
                item_id: CategorizationArray[i],
                item_text:CategorizationArray[i]
              }
            );
          }
          var ProductsArray = this.NewsResult[0].Products;
          this.selectedItemsProducts=[];
          for (var i = 0; i < ProductsArray.length; i++) {
            this.selectedItemsProducts.push(
              {
                item_id: ProductsArray[i],
                item_text:ProductsArray[i]
              }
            );
          }
          var IndicationsArray = this.NewsResult[0].Indications;
          this.selectedItemsIndication=[];
          for (var i = 0; i < IndicationsArray.length; i++) {
            this.selectedItemsIndication.push(
              {
                item_id: IndicationsArray[i],
                item_text:IndicationsArray[i]
              }
            );
          }
          this.newsmodel = {
            ID: this.newsId,
            Title: this.NewsResult[0].Title,
            ShortDescription: this.NewsResult[0].ShortDescription,
            LongDescription: this.NewsResult[0].LongDescription,
            Categorization: this.NewsResult[0].Categorization,
            Products: this.NewsResult[0].Products,
            Source: this.NewsResult[0].Source,
            SourceLink: this.NewsResult[0].SourceLink,
            Indications: this.NewsResult[0].Indications,
            CompanyId: companyid,
            CreatedBy: this.NewsResult[0].CreatedBy,
            ModifiedBy: null//this.sharedService.getUserDetail('Userid')
          }

          this.NewsData = this.NewsResult[0]
          this.CreateEmailBody();
          this.NewsReadContent = [this.NewsData.LongDescription];
        }
        
          
      }, error => {
        console.log(error)
      })
    }
    else if(this.articleType == 'repo'){
      this.repoService.GetSharedRepositoryDetailsById(this.newsId).subscribe(result => {
        if (result) {
          this.RepoResult = result; 
          if (this.RepoResult) {
            this.RepoData = this.RepoResult[0];
            console.log(this.RepoData)
            var repo = this.RepoResult[0].Repo;         
            for(let index=0;index<repo.length;index++){            
              var Attachments = repo[index].Attachment;
              Attachments = Attachments.filter(xx => xx.IsActive == true); 
              repo[index].Attachment = Attachments;
            }
            if (repo.length > 0) {
              this.AttachmentResult = repo.filter(xx => xx.IsActive == true);
            }    
          }   
        }
      }, error => {      
        console.log(error)
      })
    }
  }
  onSpeechClick() {
    console.log(this.NewsReadContent);
    for (const text of this.NewsReadContent) {
      const v = this.speechFactory.text(text);
      this.speechService.speak(this.speechFactory.text(text));
    }
  }
  onSpeechPause() {
    console.log("Pause");
    this.speechService.pause();
  }
  onSpeechResume() {
    console.log("Resume");
    this.speechService.resume();
  }
  onShareEmail(id){
    var request =
    {​​​​​​​​
      email: this.ShareEmailId,
      emailSubject : 'CI Portal - Hey! your friend shared article to you',
      emailBody: this.EmailBody
    }​​​​​​​​     
    this.newsService.SendSharedNewsEmail(request).subscribe(result => {        
      if(result){
        $(".errorfp-success").text('Email sent successfully..!!').show().delay(5000).fadeOut();   
        return false; 
      }
    }, error => {
      console.log('Failed to send email.' + error.reason + error.status);     
      $(".errorfp-msg").text(error.reason).show().delay(5000).fadeOut();   
      return false; 
    })
        
      
  }
  CreateEmailBody(){
    this.EmailBody = '<html><body><table width=100%>' 
                  + '<tr><td width=75%>' + this.NewsData.Title + '</td><td>' + this.sharedService.ConvertDateYYYYMMDD(this.NewsData.CreatedOn) + '</td></tr>' 
                  + '<tr><td colspan=2>' + this.NewsData.ShortDescription + '</td></tr>'
                  + '<tr><td colspan=2><a href='+this.WebsiteLink+'/sharednews?share='+ this.NewsData._id + '>Click here</a> to read full article.</td></tr>'
                  + '</table></body><html>';
  }
  onPrinterClick(){
    
  }
}
